/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2021-12-27 14:42:17
 * @LastEditTime : 2023-04-14 15:39:31
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\basicConfig\priceMaintenance.js
 */
/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2022-02-23 10:50:10
 * @LastEditors: hexy
 * @LastEditTime: 2022-06-08 10:46:41
 * @Description: 
 * @FilePath: \ICPSxin\src\api\basicConfig\priceMaintenance.js
 */
export const queryPage = '/icps/system/sign/basics/information/price/queryPage'
/**导出模板*/
export const exportExample = '/icps/system/sign/basics/information/price/exportExample'
import request from '@/utils/request'
/**保存或修改数据*/
export function savePrice(data) {
  return request({
    url: '/icps/system/sign/basics/information/price/saveOrUpdate',
    method: 'post',
    data
  })
}
/**获取详情*/
export function queryDetail(data) {
  return request({
    url: '/icps/system/sign/basics/information/price/queryDetail',
    method: 'post',
    data
  })
}
/**删除*/
export function deletePrice(data) {
  return request({
    url: '/icps/system/sign/basics/information/price/delete',
    method: 'post',
    data
  })
}
/**查询信息价样式*/
export function queryPatternList(data) {
  return request({
    url: '/icps/system/sign/basics/information/price/queryPatternList',
    method: 'post',
    data
  })
}
/**添加信息价样式*/
export function savePattern(data) {
  return request({
    url: '/icps/system/sign/basics/information/price/savePattern',
    method: 'post',
    data
  })
}
/**删除信息价样式*/
export function deletePattern(params) {
  return request({
    url: '/icps/system/sign/basics/information/price/deletePattern',
    method: 'get',
    params,
  })
}
/**更新信息价样式*/
export function updateTabel(params) {
  return request({
    url: '/icps/system/sign/basics/information/price/updateTabel',
    method: 'get',
    params,
  })
}
/**获取标号*/
export function getListByTypeId(data) {
  return request({
    url: '/icps/system/sign/basics/namingRule/getListByTypeId',
    method: 'post',
    data,
  })
}
// /**导入信息价*/
// export function importList(data) {
//   return request({
//     url: '/icps/system/sign/basics/information/price/importList',
//     method: 'post',
//     data
//   })
// }
